{"id":"CookiesButton","prefabs":{"default":{"children":[{"component":"CookiesButton","options":"options:*"}]}}}